module.exports = __webpack_public_path__ + "static/media/arrival-notification-sound.23cb4772.mp3";